/* eslint-disable max-len */
import React from 'react';

interface Props extends React.SVGProps<SVGSVGElement> {
  color?: string;
}

const Equal: React.FC<Props> = ({ ...props }) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M18.25 11.6772C18.6642 11.6772 19 12.013 19 12.4272C19 12.8415 18.6642 13.1772 18.25 13.1772H1.75C1.33579 13.1772 1 12.8415 1 12.4272C1 12.013 1.33579 11.6772 1.75 11.6772H18.25ZM18.25 7.32275C18.6642 7.32275 19 7.65854 19 8.07275C19 8.48697 18.6642 8.82275 18.25 8.82275H1.75C1.33579 8.82275 1 8.48697 1 8.07275C1 7.65854 1.33579 7.32275 1.75 7.32275H18.25Z"
      fill={props.color ?? props?.style?.color}
    />
  </svg>
);

export default Equal;
